import type { MonthlyBillingStatDTO } from '../subscriptionBillingStat.types';

export class MonthlyBillingStatModel {
  private readonly _dto: MonthlyBillingStatDTO;

  constructor(dto: MonthlyBillingStatDTO) {
    this._dto = dto;
  }

  get originDTO(): MonthlyBillingStatDTO {
    return this._dto;
  }

  get month() {
    return this._dto.month;
  }

  get monthlyPayment() {
    return this._dto.monthlyPayment;
  }

  get monthlyPaymentEstimate() {
    return this._dto.monthlyPaymentEstimate;
  }

  get monthlyPaymentEstimateGrowthRate() {
    return this._dto.monthlyPaymentEstimateGrowthRate;
  }

  get subscriptionCount() {
    return this._dto.subscriptionCount ?? 0;
  }

  get totalUserCount() {
    return this._dto.subscriptionUserStat?.totalUserCount ?? 0;
  }

  get abnormalActiveMemberCount() {
    return this._dto.subscriptionUserStat?.abnormalActiveMemberCount ?? 0;
  }

  get abnormalBlockedMemberCount() {
    return this._dto.subscriptionUserStat?.abnormalBlockedMemberCount ?? 0;
  }

  get billableUserCount() {
    return this._dto.subscriptionUserStat?.billableUserCount ?? 0;
  }

  get billableMemberCount() {
    return this._dto.subscriptionUserStat?.billableMemberCount ?? 0;
  }

  get billableNonMemberCount() {
    return this._dto.subscriptionUserStat?.billableNonMemberCount ?? 0;
  }
}
